import { NavLink } from "react-router-dom";
import { Link, ListItemButton, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDeviceType } from "@hooks/useDeviceType";
import { useNavigation } from "../hook/useNavigation";
import { useStyle } from "../style";
import { ILink } from "../hook/useNavigationLinks";

interface IParams {
    link: ILink;
    onNavigate?(): void;
}

export const NavigationLinkMobile = (props: IParams) => {
    const { link, onNavigate } = props;
    const { isDesktop } = useDeviceType();
    const { t } = useTranslation("header");
    const { isRouteActive, isWordPressLink } = useNavigation();
    const isActive = isRouteActive(link.route);
    const isExternal = isWordPressLink(link.route);
    const { classes } = useStyle({ isDesktop, isActive });

    return (
        <ListItemButton
            className={classes.drawerMenuItem}
            component={isExternal ? Link : NavLink}
            disableGutters
            divider
            href={isExternal ? link.route : undefined}
            id={link.id}
            to={isExternal ? undefined : link.route}
            onClick={onNavigate}
        >
            <Typography className={classes.drawerMenuItemText} variant="large">
                {link.title}
                {link.showNewBadge && (
                    <Box className={classes.newBadge} component="span">
                        {t("new")}
                    </Box>
                )}
            </Typography>
        </ListItemButton>
    );
};
